export default __webpack_public_path__ + "./fonts/FSMeWeb-Light.otf";